export class AdvancedMapBounds {
    maxLongitude: number;
    minLongitude: number;
    maxLatitude: number;
    minLatitude: number;

    constructor(maxLong: number, minLong: number, maxLat: number, minLat: number) {
        this.maxLongitude = maxLong ?? 0
        this.minLongitude = minLong ?? 0
        this.maxLatitude = maxLat ?? 0
        this.minLatitude = minLat ?? 0
    }
}

export class AdvancedMapDataIn {
    type: AdvancedMapPinType;
    bounds: AdvancedMapBounds;
    filter: AdvancedMapFilter = new AdvancedMapFilter();

    constructor() { }
}

export class AdvancedMapDataOut {
    id: number;
    type: AdvancedMapPinType;
    longitude: number;
    latitude: number;
    connectedCustomers?: number;
    objectCategory?: ObjectCategory;
    constructor(id: number, type: AdvancedMapPinType, longitude: number, latitude: number, connectedCustomers?: number, objectCategoty?:ObjectCategory) {
        this.id = id;
        this.type = type;
        this.longitude = longitude;
        this.latitude = latitude;
        this.connectedCustomers = connectedCustomers;
        this.objectCategory = objectCategoty
    }
}

export class AdvancedMapFilter {
    selectedAreas: number[] = [];
    selectedSubGeographicalRegions: number[] = [];
    selectedDts: number[] = [];
    selectedPoles: number[] = [];
    selectedBuildings: number[] = [];
    selectedCimSubstations: number[] = [];
    mapFilterSingle: AdvancedMapFilterSingleSpecific = new AdvancedMapFilterSingleSpecific();
    isSingle: boolean = false;

    constructor() {
        this.selectedAreas = [];
        this.selectedSubGeographicalRegions = [];
        this.selectedDts = [];
        this.selectedPoles = [];
        this.selectedBuildings = [];
        this.selectedCimSubstations = [];
        this.mapFilterSingle = new AdvancedMapFilterSingleSpecific();
        this.isSingle = false;
    }
}

export class AdvancedMapFilterSingleSpecific {
    buildingId: number = 0;
    dtId: number = 0;
    poleId: number = 0;
    cimSubstationId: number = 0;
}

export class AdvanceMapAnalyticsCounts {
    buildingAnalytics: AdvanceMapBuildingCounts = new AdvanceMapBuildingCounts();
    customerAnalytics: AdvanceMapCustomerCounts = new AdvanceMapCustomerCounts();
    dtAnalytics: AdvanceMapDtCounts = new AdvanceMapDtCounts();
    poleAnalytics: AdvanceMapPoleCounts = new AdvanceMapPoleCounts();
    feederAnalytics: AdvanceMapFeederCounts = new AdvanceMapFeederCounts();
    substationAnalytics: AdvanceMapSubstationCounts = new AdvanceMapSubstationCounts();
    tsAnalytics: AdvanceMapTsCounts = new AdvanceMapTsCounts();
    deviceAnalytics: AdvanceMapDeviceCounts = new AdvanceMapDeviceCounts();
}

export class AdvanceMapFeederCounts {
    count: number;
    color: string = '#083F72';
}
export class AdvanceMapSubstationCounts {
    count: number;
    color: string = '#F16E0F';
}

export class AdvanceMapTsCounts {
    count: number;
    color: string = '#DC3030';
}

export class AdvanceMapDeviceCounts {
    count: number;
    color: string = '#6922DB';
}
export class AdvanceMapBuildingCounts {
    count: number;
    color: string = '#BCBC03';
}

export class AdvanceMapCustomerCounts {
    count: number;
    color: string = '#479A3F';
}

export class AdvanceMapDtCounts {
    count: number;
    color: string = '#60951B';
}

export class AdvanceMapPoleCounts {
    count: number;
    color: string = '#6C2E40';
}

export class ConnectedAssets {
    parentLongitude: number;
    parnetLatitude: number;
    childLongitude: number;
    childLatitude: number;
    voltage: Voltage;

    constructor(parentLongitude: number, parentLatitude: number, childLongitude: number, childLatitude: number, voltage: Voltage) {
        this.parentLongitude = parentLongitude;
        this.parnetLatitude = parentLatitude;
        this.childLongitude = childLongitude;
        this.childLatitude = childLatitude;
        this.voltage = voltage;
    }

}

export class AdvancedMapClustering {
    useClusteringSubstations: boolean;
    useClusteringBuildings: boolean;
    useClusteringPoles: boolean;
    useClusteringDts: boolean;
    useClusteringBatchObjects: boolean;

    constructor(data?: boolean) {
        this.useClusteringSubstations = data ?? false;
        this.useClusteringBuildings = data ?? false;
        this.useClusteringDts = data ?? false;
        this.useClusteringPoles = data ?? false;
        this.useClusteringBatchObjects = data ?? false;
    }
}

export enum AdvancedMapPinType {
    Dt = 0,
    Building = 1,
    Pole = 2,
    Ts = 3,
    Ss = 4,
    BatchObject = 5,
    CimSubstations = 6,
    CimTransmissionStation = 7,
    CimInjectionSubstation = 8,
    CimDistributionSubstation = 9
}

export enum Voltage {
    LV = 1,
    MV = 2,
    HV = 3
}
export enum ObjectCategory {
    Building = 1,
    LvPole = 2,
    MvPole = 3,
    HvPole = 4,
    DtPoleMounted = 5,
    DtGroundMounted = 6,
    InjectionSubstation = 7,
    TransmissionStation = 8,
}

export enum AdvancedMapSearchType {
    Location,
    AssetName_TS,
    AssetName_F33,
    AssetName_IS,
    AssetName_F11,
    AssetName_DS,
    AssetName_CimSubstation,
    AssetName_CimAcLine,
    AssetName_LVPole,
    AssetName_Building,
    AssetSlrn_DS,
    AssetSlrn_LVPole,
    AssetSlrn_Building,
    AssetSlrn_Meter,
    AccountNumber,
    MeterNumber,
    None
}
